import { ml_kem1024 } from '@noble/post-quantum/ml-kem';
import { AsymmetricEncryptionType } from '@streamr/trackerless-network';
export class MLKEMKeyPair {
    privateKey;
    publicKey;
    constructor(privateKey, publicKey) {
        this.privateKey = privateKey;
        this.publicKey = publicKey;
    }
    getPublicKey() {
        return this.publicKey;
    }
    getPrivateKey() {
        return this.privateKey;
    }
    // eslint-disable-next-line class-methods-use-this
    getEncryptionType() {
        return AsymmetricEncryptionType.ML_KEM;
    }
    static create() {
        const keyPair = ml_kem1024.keygen();
        return new MLKEMKeyPair(Buffer.from(keyPair.secretKey), Buffer.from(keyPair.publicKey));
    }
}
